import { authHeader } from "../../../auth";

export default {
    name: "Admins",
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            userType: 'admin',
            password: '',
            confirmPassword: '',
            inputTypePassword: "password",
            inputTypeConfirmPassword: "password",
            iconStatus: true,
            iconFlag: true,
            setURL: '',
            singleAdmin: {},
            id: localStorage.getItem('id'),
            dataList: []
        }
    },
    async created() {
        document.title = "Dispo -  Admin";
        this.setURL = this.$serverURL + this.$api.user.adminUserList;
        this.dataList = await this.getDataList(this.setURL);
        var scripts = [
            "/core/assets/plugins/datatable/js/jquery.dataTables.min.js",
            "/core/assets/plugins/datatable/js/dataTables.bootstrap5.min.js",
            "/core/assets/js/table-datatable.js"
        ];
        scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.head.appendChild(tag);
        });
        let style = document.createElement('link');
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = '/core/assets/plugins/datatable/css/dataTables.bootstrap5.min.css';
        document.head.appendChild(style);
    },
    methods: {
        checkValidation: function () {
            if (!this.firstName) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter first name!"
                });
                return false;
            }
            if (!this.lastName) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter last name!"
                });
                return false;
            }
            if (!this.email) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter email!"
                });
                return false;
            }
            if (!this.phone) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter phone number!"
                });
                return false;
            }
            if (this.phone.length <= 9) {
                this.$swal.fire({
                    icon: "info",
                    title: "Phone number nust be at least 10 digits!"
                });
                return false;
            }
            if (!this.password) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter password!"
                });
                return false;
            }
            if (!this.confirmPassword) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter confirm password!"
                });
                return false;
            }
            if (this.password != this.confirmPassword) {
                this.$swal.fire({
                    icon: "info",
                    title: "Password and Confirm Password does not match!"
                });
                return false;
            }
            return true;
        },
        addAdmin: async function () {
            if (this.checkValidation()) {
                let data = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    password: this.password,
                    phone: this.phone,
                    country: "United States of America",
                    userType: this.userType
                };
                let config = {
                    method: "POST",
                    url: this.$serverURL + this.$api.user.registrationURL,
                    data: data,
                    headers: authHeader()
                };
                let response = await this.postData(config);
                if (response.statusCode == 201) {
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                    document.getElementById('addModalCloseButton').click();
                    this.firstName = '';
                    this.lastName = '';
                    this.email = '';
                    this.phone = '';
                    this.userType = 'admin';
                    this.password = '';
                    this.confirmPassword = '';
                    this.inputTypePassword = "password";
                    this.inputTypeConfirmPassword = "password";
                }
                this.dataList = await this.getDataList(this.setURL);
            }
        },
        editAdmin: function (data) {
            this.singleAdmin = data;
        },
        checkUpdateValidation: function () {
            if (!this.singleAdmin.firstName) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter first name!"
                });
                return false;
            }
            if (!this.singleAdmin.lastName) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter last name!"
                });
                return false;
            }
            if (!this.singleAdmin.email) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter email!"
                });
                return false;
            }
            if (!this.singleAdmin.phone) {
                this.$swal.fire({
                    icon: "info",
                    title: "Please enter phone number!"
                });
                return false;
            }
            if (this.singleAdmin.phone.length <= 9) {
                this.$swal.fire({
                    icon: "info",
                    title: "Phone number nust be at least 10 digits!"
                });
                return false;
            }
            return true;
        },
        updateAdmin: async function () {
            if (this.checkUpdateValidation()) {
                let data = {
                    firstName: this.singleAdmin.firstName,
                    lastName: this.singleAdmin.lastName,
                    phone: this.singleAdmin.phone,
                    userType: this.singleAdmin.userType
                };
                let config = {
                    method: "PATCH",
                    url: this.$serverURL + this.$api.user.singleUserURL + this.singleAdmin.id,
                    data: data,
                    headers: authHeader()
                };
                let response = await this.updateData(config);
                if (response.statusCode == 200) {
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
                document.getElementById('editModalCloseButton').click();
                this.singleAdmin = {};
                this.dataList = await this.getDataList(this.setURL);
            }
        },
        changePasswordType: function () {
            if (this.inputTypePassword == "password") {
                this.inputTypePassword = "text";
                this.iconStatus = false;
            }
            else if (this.inputTypePassword == "text") {
                this.inputTypePassword = "password";
                this.iconStatus = true;
            }
        },
        changeConfirmPasswordType: function () {
            if (this.inputTypeConfirmPassword == "password") {
                this.inputTypeConfirmPassword = "text";
                this.iconFlag = false;
            }
            else if (this.inputTypeConfirmPassword == "text") {
                this.inputTypeConfirmPassword = "password";
                this.iconFlag = true;
            }
        },
        deleteAdmin: async function (id) {
            this.$swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Delete'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        let config = {
                            method: 'DELETE',
                            url: this.$serverURL + this.$api.user.singleUserURL + id,
                            headers: authHeader()
                        }
                        await this.deleteData(config);
                        this.dataList = await this.getDataList(this.setURL);
                    } catch (error) {
                        this.$swal.fire({
                            icon: "error",
                            text: error.response.data.message
                        });
                    }
                }
            })
        }
    }
}